import { render, staticRenderFns } from "./FormInventoryFile.vue?vue&type=template&id=9abe04b6"
import script from "./FormInventoryFile.vue?vue&type=script&lang=js"
export * from "./FormInventoryFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports